import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询简单道具列表
export const querySceneProps: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSceneProps', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/v1/asset/prop/pagelist', payload);
    commit('setSceneProps', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setSceneProps', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询简单道具详情
export const queryScenePropDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setScenePropDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/asset/prop/${payload}/detail`);
    commit('setScenePropDetail', { data: res });
  } catch (e) {
    commit('setScenePropDetail', { data: null });
  }
};

// 编辑简单道具
export const editSceneProp: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/prop/modify', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除简单道具
export const deleteSceneProp: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/prop/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 上下架简单道具
export const shelfSceneProp: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/prop/publish', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 批量刷新索引
export const refreshScenePropIndex: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/batch/refresh', payload);
    await $http.post('/v1/asset/item/refresh', payload);
    store.commit('common/setToast', { visible: true, text: '索引刷新成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 更新缩略图
export const updateScenePropThumb: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setScenePropThumb', { ...state.thumb, loading: true });
    const res = await $http.post('/v1/asset/prop/modifyimg', payload);
    commit('setScenePropThumb', { data: res, loading: false });
  } catch (e) {
    commit('setScenePropThumb', { data: null, loading: false });
  }
};

// 新增价格
export const addScenePropPrice: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setPriceDialog', { ...state.priceDialog, loading: true });
    await $http.post('/item/business/model/add', payload);
  } finally {
    commit('setPriceDialog', { visible: false, loading: true });
  }
};

// 编辑价格
export const editScenePropPrice: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setPriceDialog', { ...state.priceDialog, loading: true });
    await $http.post('/item/business/model/modify', payload);
  } finally {
    commit('setPriceDialog', { visible: false, loading: true });
  }
};

// 删除过滤配置
export const deleteScenePropFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/prop/filterdelete', payload);
    return true;
  } catch (e) {
    return false;
  }
};

// 保存过滤配置
export const saveScenePropFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/prop/filterbatchmodify', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  }  catch (e) {
    return;
  }
};
